import React from 'react';
import { useSelector } from 'react-redux';
import { selectProfessionalSearchUrl } from '../../../../selectors/selectProfessionalSearchUrl';

import { SummaryProfiessionalSearch } from '../../../components/Summary/components/SummaryProfessionalSearch';
import { trackProfessionalSearchClick } from './tracking';

export const SummaryProfessionalSearchContainer = () => {
  const link = useSelector(selectProfessionalSearchUrl);

  const handleProfessionalSearchLinkClick = React.useCallback(() => {
    trackProfessionalSearchClick();
  }, []);

  return <SummaryProfiessionalSearch link={link} onClick={handleProfessionalSearchLinkClick} />;
};

SummaryProfessionalSearchContainer.displayName = 'SummaryProfessionalSearchContainer';
